// Pagina master unificata "Modelli AI": 2 tab interne (Piattaforma / Custom).
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@easyflow/ui-master/components/ui/tabs';
import { Cpu, PlugZap } from 'lucide-react';
import AIModelsPlatform from '@/pages/AIModelsPlatform';
import CustomAIMasterSection from '@/pages/CustomAIMasterSection';

export default function AIModelsUnified() {
  return (
    <div className="space-y-6">
      <Tabs defaultValue="platform" className="space-y-6">
        <TabsList>
          <TabsTrigger value="platform" className="gap-2">
            <Cpu className="h-4 w-4" /> Piattaforma
          </TabsTrigger>
          <TabsTrigger value="custom" className="gap-2">
            <PlugZap className="h-4 w-4" /> Custom
          </TabsTrigger>
        </TabsList>

        <TabsContent value="platform" className="space-y-8">
          <AIModelsPlatform />
        </TabsContent>
        <TabsContent value="custom">
          <CustomAIMasterSection />
        </TabsContent>
      </Tabs>
    </div>
  );
}
